module.exports = __webpack_public_path__ + "static/media/no_img_player_detail_cheerleader_m.543807cc.png";